import React, { createContext, useCallback, useState } from 'react'

export type FieldSearchContextType = {
    searchValue: string
    isVisible: boolean
    handleSearch: (value: string) => void
    clearSearch: () => void
    showSearch: () => void
    hideSearch: () => void
}

export const FieldSearchContext = createContext<FieldSearchContextType | null>(null)

type FieldSearchProviderProps = {
    children: React.ReactNode
}

export const FieldSearchProvider: React.FC<FieldSearchProviderProps> = ({ children }) => {
    const [searchValue, setSearchValue] = useState('')
    const [isVisible, setIsVisible] = useState(false)

    const handleSearch = useCallback((value: string) => setSearchValue(value), [])

    const clearSearch = useCallback(() => setSearchValue(''), [])

    const showSearch = useCallback(() => setIsVisible(true), [])

    const hideSearch = useCallback(() => {
        setIsVisible(false)
        clearSearch()
    }, [clearSearch])

    const contextValue: FieldSearchContextType = {
        searchValue,
        isVisible,
        handleSearch,
        clearSearch,
        showSearch,
        hideSearch,
    }

    return (
        <FieldSearchContext.Provider value={contextValue}>{children}</FieldSearchContext.Provider>
    )
}
